<template>
  <div class="descriptions-item">
    <div class="descriptions-item-label" v-if="label">{{ label }}：</div>
    <div class="descriptions-item-value"><slot /></div>
  </div>
</template>
<script>
export default {
  name: 'DescriptionsItem',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.descriptions-item {
  display: flex;
  align-items: center;
  .descriptions-item-label {
    font-size: 14px;
    font-family: PingFang SC;
    color: rgba(127,152,186,1);
  }
  .descriptions-item-value {
    font-size: 14px;
    font-family: PingFang SC;
    color: rgba(75,75,75,1);
  }
}
</style>